
// @ts-nocheck

import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { getAuth } from "../../api/authApi";
import { fetchUserTable } from "../../api/userApi";


export const login = createAsyncThunk(
    "auth/login",
    async (data: {email:string,password:string}, { dispatch, rejectWithValue }) => {
      dispatch(resetStatus());
  
      try {
        return await getAuth(data)
      } catch (error: any) {
        return rejectWithValue(error.message);
      }
    }
  );

  export const userTable = createAsyncThunk(
    "auth/userTable",
    async ({ page, limit }: { page: number; limit: number }, { dispatch, rejectWithValue }) => {
      dispatch(resetStatus());
  
      try {
        return await fetchUserTable(page, limit)
      } catch (error: any) {
        return rejectWithValue(error.message);
      }
    }
  );

  const authSlice = createSlice({
    name: "auth",
    initialState: {
      user: [] as any[],
      users: [] as any[],

     
      status: null as boolean | null,
      msg: "",

    },
    reducers: {
      resetStatus(state) {
        state.status = null;
        state.msg = "";
      },

      logout(state) {
        state.status = null;
        state.msg = "";
        localStorage.removeItem('token');
      },
    },
    extraReducers: (builder) => {
      builder
        .addCase(login.fulfilled, (state, action: PayloadAction<any[]>) => {
          state.status = true;
          console.log(action.payload,'action.payload');
          
          state.user = action.payload.data;
        })
        .addCase(userTable.fulfilled, (state, action: PayloadAction<any[]>) => {
          state.status = true;
          console.log(action.payload,'action.payload');
          console.log(action.payload,"action.payload.data");
          
          state.users = action.payload;
        })
      
    },
  });
  
  export const { resetStatus , logout } = authSlice.actions;
  export default authSlice.reducer;
  